import React, { useState, useRef } from "react";

import Modal from "./Modal";
import { MODAL_CLOSE } from "src/constants/images";
import { GoInfo } from "react-icons/go";

import IconService from "icon-sdk-js/build/icon-sdk-js.web.min.js";

const SalePriceModal = ({
  onChange,
  onClose,
  isVisible,
  setPriceHandler,
  price,
  salePrice,
  fee_cut_rate,
}) => {
  const inputRef = useRef();
  const [validation, setValidation] = useState("");
  // const [getPrice, setPrice] = useState("");

  const onChangePrice = () => {
    onClose();
    setPriceHandler();
  };

  const decimalCount = (num) => {
    // Convert to String
    const numStr = String(num);
    // String Contains Decimal

    if (numStr.includes(".")) {
      return numStr.split(".")[1].length;
    }
    // String Does Not Contain Decimal

    return 0;
  };

  const handleClose = () => {
    onClose();
    setValidation("");
  };

  // const priceChange = (e) =>{
  //   const dataPrice = e.target.value;
  //   setPrice(dataPrice)
  // }

  const handleValidation = (e) => {
    const value = e.target.value;

    if (value == "") {
      setValidation("Price field shouldn't be empty");
    } else if (decimalCount(value) > 18) {
      setValidation("Price can only be set up to 18 decimals.");
    } else if (value > 0) {
      setValidation("");
    } else if (value > 800000000) {
      setValidation("Price can only be set up to 800 millions");
    } else {
      setValidation("Price range cannot have negative number.");
    }
  };

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="name-modal card px-4 py-3"
    >
      <div className="header px-2 mb-1">
        <div className=" d-flex border-0 justify-content-between mb-0 flex-row">
          <h4 className="mb-2">
            {salePrice >= 0
              ? `Currently listed at ${salePrice} ICX`
              : "Set Price"}
          </h4>
          <span
            onClick={() => handleClose()}
            onKeyPress={(e) => e.code == "Enter" && handleClose()}
            className="close-modal"
          >
            <img src={MODAL_CLOSE.SOURCE} alt="close" />
          </span>
        </div>
      </div>
      <div className="body d-flex flex-column my-2 input-group">
        <div>
          <input
            ref={inputRef}
            type="number"
            className={`form-control ${validation !== "" && "error"}`}
            id="price"
            aria-describedby="price"
            placeholder="Price (ICX)"
            onChange={onChange} //priceChange value = {getPrice}
            onBlur={handleValidation}
            required
          />
        </div>
        <div className="d-flex  align-items-center">
          <p className="my-3 align-self-start px-1 note_sale mt-3">
            GangstaBet Marketplace charges{" "}
            {fee_cut_rate ? fee_cut_rate : "null"}% as transaction fees.
          </p>

          <div className="sale-price-tooltip">
            <div className="sale-tt">
              <small className="text-muted">
                The fees are used for development <br /> and marketing of the
                ecosystem.
              </small>
            </div>
            <span className="info text-muted" style={{ cursor: "pointer" }}>
              <GoInfo />
            </span>
          </div>
        </div>

        {/* <div className="my-3 d-flex flex-column p-3 infoBackground rounded  w-100">
          <div className="align-self-start"><small>GangstaBet Price: <strong>{getPrice}</strong> ICX </small></div>
          <div className="align-self-start"><small>Transaction Fees (3.00%):<strong>{(getPrice*3)/100}</strong> ICX </small></div>
          <div className="align-self-start"><small className="text-primary">You Will Receive: <strong>{getPrice - ((getPrice*3)/100) }</strong> ICX </small></div>

        </div> */}
      </div>
      <p class="text-center text-danger mb-1">{validation}</p>
      <div className="footer text-center mt-2 pb-3">
        <button
          className="btn btn-primary"
          disabled={validation != ""}
          onClick={onChangePrice}
        >
          {salePrice >= 0 ? "Update" : "Set"} Price
        </button>
        {/* 
        <span className="helper-text text-center pt-2 d-block">
          *The price of Gangstar will be set on ICX.
        </span> */}
      </div>
    </Modal>
  );
};

export default SalePriceModal;
